module.exports = __webpack_public_path__ + "img/5-营销互动-03.1364aa74.png";